import { AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostListener } from '@angular/core';

type ScrollMode = 'MANUAL' | 'PROPAGATED';

@Component({
  selector: 'app-comment-scroll-container',
  templateUrl: './comment-scroll-container.component.html',
  styleUrls: ['./comment-scroll-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentScrollContainerComponent implements AfterViewChecked, AfterViewInit {
  private currentScrollMode: ScrollMode = 'PROPAGATED';

  constructor(private elementRef: ElementRef) {}

  @HostListener('scroll')
  public commentContainerScroll() {
    if (this.elementRef) {
      this.currentScrollMode =
        this.elementRef.nativeElement.offsetHeight + this.elementRef.nativeElement.scrollTop >= this.elementRef.nativeElement.scrollHeight
          ? 'PROPAGATED'
          : 'MANUAL';
    }
  }

  public ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  ngAfterViewInit(): void {
    this.currentScrollMode = 'PROPAGATED';
    this.scrollToBottom();
  }

  private scrollToBottom() {
    if (this.elementRef && this.currentScrollMode === 'PROPAGATED') {
      this.elementRef.nativeElement.scrollTop = this.elementRef.nativeElement.scrollHeight;
    }
  }
}
